import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles.css'

var rg4js = require('raygun4js')
var pjson = require('../package.json');

Vue.config.productionTip = false

rg4js('apiKey', process.env.VUE_APP_RAYGUN_API_KEY)
rg4js('enablePulse', true)
rg4js('setVersion', pjson.version)
rg4js('options', {
  allowInsecureSubmissions: true,
  ignoreAjaxAbort: true,
  ignoreAjaxError: true,
  debugMode: process.env.VUE_APP_LOG,
  ignore3rdPartyErrors: false,
  wrapAsynchronousCallbacks: true,
  disableErrorTracking: false,
  disablePulse: false,
  pulseMaxVirtualPageDuration: 1800000,
  pulseIgnoreUrlCasing: false,
  automaticPerformanceCustomTimings: false
});
rg4js('enableCrashReporting', true)
Vue.config.errorHandler = function(err, vm, info) {
  rg4js('send', {
    error: err,
    customData: [{ info: info }]
  });
};

Vue.config.warnHandler = function(msg, vm, trace) {
  rg4js('send', {
    error: msg,
    customData: [{ info: trace }]
  });
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
